"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.experimentCategoryEnumReverse = exports.experimentCategoryEnum = void 0;
const experimentCategoryEnum = {
  TRADITIONAL_FRONT_END_EXPERIMENTATION: 1,
  CMS_CONTENT_EXPERIMENTATION: 2
};
exports.experimentCategoryEnum = experimentCategoryEnum;
const experimentCategoryEnumReverse = {
  1: 'traditional_front_end_experimentation',
  2: 'cms_content_experimentation'
};
exports.experimentCategoryEnumReverse = experimentCategoryEnumReverse;